import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20282 20222"
    {...props}
  >
    <path
      d="M11183 135c2354 243 4465 1299 6049 2883 369 369 709 766 1017 1188h-1616l-287-301c-1170-1170-2669-2012-4347-2373l-816-1397zm8144 5945c542 1233 843 2596 843 4030 0 1420-296 2771-828 3995l-817-1398c254-821 391-1693 391-2597 0-918-141-1804-403-2636l814-1394zM3936 16314c1179 1180 2693 2025 4386 2382l813 1392c-2367-235-4493-1295-6085-2887-386-386-740-803-1059-1247h1605l340 360zm-2570-6204c0 904 137 1776 391 2597l-817 1398c-532-1224-828-2575-828-3995 0-1433 301-2796 842-4029l815 1393c-262 832-403 1718-403 2636zm1684-7092C4634 1434 6745 378 9099 135l-817 1397c-1677 361-3176 1203-4346 2373l-287 301H2033c308-422 648-819 1017-1188zm8910 15678c1693-357 3207-1202 4386-2382l340-360h1605c-319 444-673 861-1059 1247-1592 1592-3718 2652-6086 2887l814-1392z"
      style={{
        fill: "#2b2a29",
        stroke: "#2b2a29",
        strokeWidth: 224.759,
      }}
      className="stroke1 fill"
    />
  </svg>
)
export default SvgComponent
